import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../config/axiosBaseQuery';
import {
  QuoteTemplate,
  CreateQuoteTemplateRequest,
  UpdateQuoteTemplateRequest,
} from './quoteTemplatesTypes';

export const quoteTemplatesApi = createApi({
  reducerPath: 'quoteTemplatesApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['QuoteTemplates'],
  endpoints: (builder) => ({
    getQuoteTemplates: builder.query<QuoteTemplate[], void>({
      query: () => ({
        url: '/api/proposals/templates',
        method: 'GET',
      }),
      providesTags: ['QuoteTemplates'],
    }),

    getQuoteTemplateById: builder.query<QuoteTemplate, string>({
      query: (id) => ({
        url: `/api/proposals/templates/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'QuoteTemplates', id }],
    }),

    createQuoteTemplate: builder.mutation<QuoteTemplate, CreateQuoteTemplateRequest>({
      query: (quoteTemplate) => ({
        url: '/api/proposals/templates',
        method: 'POST',
        data: quoteTemplate,
      }),
      invalidatesTags: ['QuoteTemplates'],
    }),

    updateQuoteTemplate: builder.mutation<
      QuoteTemplate,
      { id: string; quoteTemplate: UpdateQuoteTemplateRequest }
    >({
      query: ({ id, quoteTemplate }) => ({
        url: `/api/proposals/templates/${id}`,
        method: 'PUT',
        data: quoteTemplate,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'QuoteTemplates', id },
        'QuoteTemplates',
      ],
    }),

    deleteQuoteTemplate: builder.mutation<void, string>({
      query: (id) => ({
        url: `/api/proposals/templates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['QuoteTemplates'],
    }),
  }),
});

export const {
  useGetQuoteTemplatesQuery,
  useGetQuoteTemplateByIdQuery,
  useCreateQuoteTemplateMutation,
  useUpdateQuoteTemplateMutation,
  useDeleteQuoteTemplateMutation,
} = quoteTemplatesApi;
